<div class="modal-header" cdkDrag cdkDragRootElement=".modal-content" cdkDragHandle>
  <h5 class="modal-title">Delete Key Date - {{keyDateName}}</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="cancel()"></button>
</div>

<div class="modal-body">

  <p class="fw-semibold">Are you sure you want to delete this date?</p>

  <form autocomplete="off" [formGroup]="deleteKeyDateDetails">

    <div class="mb-1">
      <textarea class="form-control" #reason placeholder="Please enter the reason" maxlength="200" formControlName="reason" rows="3"></textarea>
      <div class="form-text text-end">{{reason.value?.length || 0}}/200</div>
    </div>

  </form>

</div>

<div class="modal-footer">
  <ng-container *ngIf="!isLoading">
    <button type="button" class="btn btn-outline-danger" [disabled]="reason.value?.length == 0" (click)="deleteKeyEvent()">Delete</button>
  </ng-container>

  <button *ngIf="isLoading" type="button" class="btn btn-danger" disabled>
    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
    Deleting...
  </button>
</div>